import React, { Fragment, useEffect, useState } from 'react';
import { translate } from '../../../Services/translation';
import { post, get } from '../../../Services/http';

const GDPRApprovalForm = (props) => {
    const [getInformationOffers, setGetInformationOffers] = useState(false);
    const [messagebeforerunoutoflenses, setMessagebeforerunoutoflenses] = useState(false);   
    const [submittopContent, setsubmittopContent] = useState('');   

    const saveApproval = () => {        
        post(`/api/gdprapproval/saveapproval`, {
            phoneNumber: props.phoneNumber,
            offers: getInformationOffers,
            messageBeforeRunOut: messagebeforerunoutoflenses
        })        
        .then(() => {
            window.location.reload();          
        });
    }

    useEffect(() => {
        get(`/api/gdprapproval/gdprapprovalsubmittopcontent`)
            .then((response) => response.json())
            .then((result) => {
                setsubmittopContent(result ? result.value : "");
            });
    }, []);

    return(
        <Fragment>
            <div className='gdpr-message-description' dangerouslySetInnerHTML={{ __html: submittopContent }}>                
            </div>
            <div>
                <div className="columns small-12">
                    <label className='form__label'>{translate("mypage.person.phone")}</label>
                    <input type="text" className='form__input' disabled value={props.phoneNumber}></input>                                       
                </div>                
            </div>
            <div>
                <div className="columns small-12 comply-row">
                    <input type="checkbox" value={getInformationOffers} onChange={(e) => setGetInformationOffers(e.target.checked)}/>
                    <label className='form__label comply'>{translate("coptikk.mypage.person.getinformationofoffers")}</label>                    
                </div>
            </div>
            <div>
                <div className="columns small-12 comply-row">
                    <input type="checkbox"  value={messagebeforerunoutoflenses} onChange={(e) => setMessagebeforerunoutoflenses(e.target.checked)}/>
                    <label className='form__label comply'>{translate("coptikk.mypage.person.messagebeforerunoutoflenses")}</label>                     
                </div>
            </div>
            <div>
                <div className="columns small-12">                    
                    <label className='form__label comply-description'>{translate("coptikk.gdprapproval.termsdescription")}</label>                     
                </div>
            </div>
            <div>
                <div className="column small-12">
                    <button className="button" onClick={() => saveApproval()}>{translate("coptikk.adminportal.gdprapproval.approve")}</button>
                </div>
            </div>
        </Fragment>
    )
}

export default GDPRApprovalForm;